import { CommonSuccessResponse } from "constants/types/common";
import {
  ExportJobDetailResponseType,
  ExportJobResponseType,
} from "constants/types/export";
import useSWR from "swr";

export const EXPORT_JOBS_KEY = "/export/jobs";

export const getExportJobDetailKey = (id: string | null) =>
  id ? `/export/jobs/${id}` : null;

export const useExportJobs = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<ExportJobResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(EXPORT_JOBS_KEY, { refreshInterval: 0, errorRetryCount: 2 });

  return {
    jobs: data?.data ?? [],
    error,
    isLoading,
    mutate,
  };
};

export const useExportJobDetail = (id: string | null) => {
  const {
    data,
    error,
    isLoading,
  }: {
    data: CommonSuccessResponse<ExportJobDetailResponseType> | undefined;
    error: any;
    isLoading: boolean;
  } = useSWR(getExportJobDetailKey(id), {
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
    errorRetryCount: 1,
  });

  return {
    job: data?.data,
    error,
    isLoading,
  };
};
